module.exports = "<span ng-if=!isMobile> <div class=\"\" style=\"\"> <div class=adult404> <img src=" + require("../img/404-adult.png") + " class=adult404img> <a href=/ ><div class=adultHomeLink>חזור לדף הבית</div></a> </div> </div> </span> <div ng-if=isMobile class=MobileContainer404 style=top:-50px> <img src=" + require("../img/404-mobile-adult.png") + " class=adult404Mobile> </div>";


//////////////////
// WEBPACK FOOTER
// ./public/views/404.html
// module id = 147
// module chunks = 0